import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { AdminService } from '../../admin.service';
import { Faq } from '../../../models/faq.model';
import { FaqService } from '../../../services/faq.service';
import { FaqCategoryService } from '../../../services/faqcategory.service';
import { FaqCategory } from '../../../models/faqcategory.model';
import { Menu } from '../../../models/menu.model';

declare var jQuery: any;

@Component({
  selector: 'app-faq-dashboard',
  templateUrl: './faq-dashboard.component.html',
  styleUrls: ['./faq-dashboard.component.css']
})
export class FaqDashboardComponent implements OnInit {
  menus: Menu[] = [];
  loading = true;
  faqs: Faq[] = [];
  faqscategory: FaqCategory[] = [];

  subscription: Subscription;
  subscriptionDelete: Subscription;

  subscriptionCategory: Subscription;

  constructor(private faqService: FaqService, private adminService: AdminService, private faqCategoryService: FaqCategoryService) { }

  ngOnInit() {

    this.faqService.httpGetFaqs();
    this.faqCategoryService.httpGetFaqsCategory();

    this.subscription = this.faqService.faqsChanged.subscribe(
      (faqs: Faq[]) => {
        setTimeout(
          () => {
            this.loading = false;
            jQuery('table').DataTable({
              "oLanguage": { "sSearch": "", "sLengthMenu": "_MENU_" },
              "pageLength": 50,
              "retrieve": true
            });
    
            jQuery('input[type=search]').addClass('btn-search');
            jQuery('input[type=search]').attr('placeholder','Search');
            jQuery('select').addClass('select_datatable');
            jQuery('select').append('<option selected>Filter</option>');
          }, 1000
        );
 
        this.faqs = faqs; 
      }
    );

    this.subscriptionCategory = this.faqCategoryService.faqsCategoryChanged.subscribe(
      (faqscategory: FaqCategory[]) => {
        this.faqscategory = faqscategory;
      }
    )

  }

  onDelete(id: number) {
    this.faqService.httpDeleteFaq(id);
  }

  cutString(title: string){
    return title.slice(0, 80);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/help/faq-dashboard/faq-dashboard.component.ts